import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {useLocation} from 'react-router-dom'

const Seo = ({title, description, noIndex, keywords, hrefLangs = [], children, ...props}) => {
    const location = useLocation()
    const currentTags = useRef([])

    useEffect(() => {
        const currentHrefs = new Set(hrefLangs.map((hl) => hl.href))
        document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((tag) => {
            if (!currentHrefs.has(tag.href)) {
                tag.remove()
            }
        })

        // Store references
        currentTags.current = []

        // Add new tags with precise formatting
        hrefLangs.forEach(({localeId, href}) => {
            // Check if tag already exists
            const exists = document.querySelector(
                `link[rel="alternate"][hreflang="${localeId}"][href="${href}"]`
            )
            if (!exists) {
                const tag = document.createElement('link')
                tag.rel = 'alternate'
                tag.href = href
                tag.hreflang = localeId.toLowerCase()
                document.head.appendChild(tag)
                currentTags.current.push(tag)
            }
        })

        // Cleanup on unmount
        return () => {
            currentTags.current.forEach((tag) => {
                if (tag.parentNode) {
                    tag.remove()
                }
            })
        }
    }, [hrefLangs, location.pathname])

    return (
        <Helmet {...props}>
            {/* Title */}
            {title && <title>{title}</title>}

            {/* Meta Tags */}
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {noIndex && <meta name="robots" content="noindex" />}

            {/* Any additional children */}
            {children}
        </Helmet>
    )
}

Seo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    noIndex: PropTypes.bool,
    children: PropTypes.node,
    keywords: PropTypes.string,
    hrefLangs: PropTypes.arrayOf(
        PropTypes.shape({
            localeId: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired
        })
    )
}

export default Seo
